import React from "react"
import { AccountCenterSummaryList } from "../features/centerSummary/AccountCenterSummaryList"
import { PeriodSelector } from "../features"
import { Stack, Typography } from "@mui/material"
import { ReimbursementCalcAllCentersDialog } from "../features/allCentersReimbursement/ReimbursementCalcAllCentersDialog"

function RevRecHome(){
    return <React.Fragment>
        <Typography className='psn-green' variant='h5'>Revenue Recognition</Typography>
        <Stack direction='row' alignItems='center' justifyContent='space-between'>
            <PeriodSelector/>
            <ReimbursementCalcAllCentersDialog/>
        </Stack>
        <AccountCenterSummaryList/>
    </React.Fragment>
}
export {RevRecHome}